var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportShareIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_44)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 4.32168L10.7358 8.64336V6.49042C8.03919 5.9299 5.90894 6.54774 4.29102 8.60552C4.5719 4.37336 7.45349 2.33101 10.7357 2.1958L10.7358 0L15.0004 4.32168Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.843262 2.90808H5.19214C4.6322 3.39304 4.12891 3.95675 3.69507 4.59994H1.6864V12.3083H11.5256V10.5113L13.2119 8.84839V13.1541C13.2119 13.6212 12.8344 14 12.3688 14H0.843262C0.377564 14 0 13.6212 0 13.1541V3.75395C0 3.28674 0.377564 2.90808 0.843262 2.90808Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportShareIconDark);
export default __webpack_public_path__ + "static/media/export-share-icon-dark.22f4c45b2b0ec45db5cda682069eafdd.svg";
export { ForwardRef as ReactComponent };